import { faEdit } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Field } from "formik";
import { cloneDeep, get, isEmpty } from "lodash";
import React, { useEffect, useState } from "react";
import { useDeepEffect } from "../../../abstracts";
import {
  FieldButtonGroup,
  FieldMultiSelectButtonGroup,
  WithDrawalCard,
} from "../../../components";
import { toOptionValuesFromMapper } from "../../../utils";
import {
  AllowMeToChooseFromOptions,
  getVestedBalanceWithoutVestingMultiplier,
  getValues,
  isFullWithdrawal,
  isOneTimePayment,
  SourceAllocationCalculationMethod,
  SourceAllocationCalculationMethodOptions,
} from "./DistributionConstantsAndFunctions";
import SourceAllocationTableComponent from "./SourceAllocationTableComponent";

export const SourceAllocationComponentSlider = (props) => {
  const {
    values,
    setValues,
    setFieldValue,
    handleChange,
    filteredSourceBalances,
    proratedDataForSourceAllocation,
    fields,
    setFilteredSourceBalances,
    sourceBalances,
    outerValues,
    isCustomSourceAllocation,
    setIsCustomSourceAllocation,
    requestedAmountEffective,
    grossAmountEffective,
    selectedWithdrawalPlanSetUp,
    selectedIndex,
    onSourceAllocationCalculationMethodChange,
    setInitialFilteredSourceBalance,
    initialFilteredSourceBalance,
    setAvailableBalanceMapForEachSourceInvestment,
    availableBalanceMapForEachSourceInvestment,
    setFilteredSourceBalancesAndAvailableAmountSplit,
    effectiveAmountWithdrawn,
    ...rest
  } = props;
  const [firstRender, setFirstRender] = useState(true);

  useDeepEffect(async () => {
    if (!firstRender) {
      const availableBalanceMapForEachSourceInvestmentTemp = setFilteredSourceBalancesAndAvailableAmountSplit(
        values
      );
      const remainingGrossAmountToBeWithdrawn = getVestedBalanceWithoutVestingMultiplier(
        availableBalanceMapForEachSourceInvestmentTemp
      );
      if (isFullWithdrawal(outerValues) && isOneTimePayment(outerValues)) {
        setFieldValue(
          fields.grossAmount,
          effectiveAmountWithdrawn(remainingGrossAmountToBeWithdrawn)
        );
      }
    }
    setFirstRender(false);
  }, [values[fields.distributionMode], sourceBalances]);

  const dataToMap = isCustomSourceAllocation
    ? get(values, fields.allocatedSourceWithdrawal, [])
    : proratedDataForSourceAllocation;
  console.log(
    "dataToMap",
    dataToMap,
    proratedDataForSourceAllocation,
    isCustomSourceAllocation
  );

  return (
    <div>
      {dataToMap && dataToMap.length <= 0 ? (
        <>
          <div className="slider-heading d-flex w-100 mb-2">Source details</div>
          <div className="ft-12 ">No Sources Available</div>
        </>
      ) : (
        <>
          <div className="slider-heading w-100 mb-2">
            <div className="pb-10">Source details</div>
            {outerValues[fields.modeOfPayment] !== 2 && (
              <>
                <Field
                  isRequired
                  size="lg"
                  name={fields.sourceAllocationCalculationMethod}
                  options={toOptionValuesFromMapper(
                    SourceAllocationCalculationMethodOptions
                  ).filter((_) =>
                    (
                      selectedWithdrawalPlanSetUp?.distributionAllocationMethod ??
                      []
                    ).includes(_.value)
                  )}
                  selectedValue={
                    values[fields.sourceAllocationCalculationMethod]
                  }
                  value={values[fields.sourceAllocationCalculationMethod]}
                  onChange={onSourceAllocationCalculationMethodChange}
                  component={FieldButtonGroup}
                />
              </>
            )}
            {/* {!isCustomSourceAllocation && (
              <div
                className="light-blue cursor-pointer ml-auto ft-14"
                onClick={() => {
                  setFieldValue(
                    [fields.customizeAllocationCalculationMethod],
                    1
                  );
                  setFieldValue(
                    [fields.sourceAllocationCalculationMethod],
                    SourceAllocationCalculationMethod.AllowMeToChoose
                  );
                  setFieldValue(
                    [fields.allocatedSourceWithdrawal],
                    proratedDataForSourceAllocation
                  );
                }}
              >
                <FontAwesomeIcon
                  icon={faEdit}
                  className="ft-14 fw-300 cursor-pointer mr-1"
                />
                Customize
              </div>
            )} */}
          </div>
          {isCustomSourceAllocation && (
            <Field
              isRequired
              name={fields.customizeAllocationCalculationMethod}
              label="Allow me to choose from"
              size="sm"
              options={toOptionValuesFromMapper(AllowMeToChooseFromOptions)}
              selectedValue={
                values[fields.customizeAllocationCalculationMethod]
              }
              onChange={(value) => {
                setFieldValue(
                  fields.customizeAllocationCalculationMethod,
                  value
                );
              }}
              //disabled={isEdit && !isSave}
              component={FieldButtonGroup}
              validate={(value) => {
                return [undefined, null, ""].includes(value)
                  ? "Required"
                  : undefined;
              }}
            />
          )}
          <>
            <div className="mt-20">
              {dataToMap.map((singleSourceBalance) => {
                return (
                  <SourceAllocationTableComponent
                    style={{ width: "900px" }}
                    isCustomSourceAllocation={isCustomSourceAllocation}
                    singleSourceBalance={singleSourceBalance}
                    filteredSourceBalances={filteredSourceBalances}
                    proratedDataForSourceAllocation={
                      proratedDataForSourceAllocation
                    }
                    {...props}
                  />
                );
              })}{" "}
            </div>
          </>
          <WithDrawalCard
            cssStyle={{
              display: "flex",
              justifyContent: "space-between",
              marginTop: "20px",
              padding: "8px",
            }}
            style={2}
          >
            <div className="heading-text2">Net Withdrawal Amount</div>
            <div className="heading-text2">
              ${" "}
              {dataToMap
                .reduce(
                  (a, b) =>
                    a + getValues(b?.sourceEmployeeMap?.sourceWithdrawalAmount),
                  0
                )
                .toFixed(2)}
            </div>
          </WithDrawalCard>
        </>
      )}
    </div>
  );
};
